"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const ImageAnnotateArrayField = (_ref) => {
  let registry = _ref.registry,
      props = _objectWithoutPropertiesLoose(_ref, ["registry"]);

  const ArrayField = registry.fields.ArrayField;
  const onAnnotateArrayChange = registry.formContext.onAnnotateArrayChange;
  return _react.default.createElement(ArrayField, _extends({}, props, {
    registry: registry,
    onChange: onAnnotateArrayChange
  }));
};

var _default = ImageAnnotateArrayField;
exports.default = _default;
module.exports = exports.default;